import React from 'react'
import Flex from 'typescript-styled-flex'
import { Trans, useTranslation } from 'react-i18next'
import {
  compareAsc,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  subDays,
  subHours,
  subMinutes,
} from 'date-fns'
import { is } from '../../MediaQuery'
import TimerBadge from './TimerBadge'

function PremiumTimer({ countTo }: IPremiumTimerProps) {
  const [currentDate, setDate] = React.useState(new Date())
  const { t } = useTranslation()
  const isDesktop = is.desktop()
  const isGreater = compareAsc(countTo, currentDate) > 0

  // eslint-disable-next-line
  let interval

  React.useEffect(() => {
    // eslint-disable-next-line
    interval = setInterval(() => setDate(new Date()), 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  function days() {
    return isGreater ? differenceInDays(countTo, currentDate) : 0
  }

  function hours() {
    return isGreater
      ? differenceInHours(subDays(countTo, days()), currentDate)
      : 0
  }

  function minutes() {
    return isGreater
      ? differenceInMinutes(
          subHours(subDays(countTo, days()), hours()),
          currentDate,
        )
      : 0
  }

  function seconds() {
    return isGreater
      ? differenceInSeconds(
          subMinutes(subHours(subDays(countTo, days()), hours()), minutes()),
          currentDate,
        )
      : 0
  }

  return (
    <Flex column={true} alignCenter={true} justifyCenter={true}>
      <div
        style={{
          fontSize: isDesktop ? '14px' : '13px',
          paddingBottom: '12px',
          paddingTop: '20px',
          textAlign: 'center',
        }}
      >
        <Trans i18nKey={'z677_able_to_repeat'} />
      </div>
      <Flex row={true} full={true} alignCenter={true} justifyCenter={true}>
        <TimerBadge>{`${days()} ${
          days() === 1 ? t('days_count_day') : t('days')
        }`}</TimerBadge>
        <TimerBadge>{`${hours()} ${t('limit_dialog_hours')}`}</TimerBadge>
        <TimerBadge>{`${minutes()} ${t('limit_dialog_minutes')}`}</TimerBadge>
        <TimerBadge style={{ marginRight: '0' }}>{`${seconds()} ${t(
          'limit_dialog_seconds',
        )}`}</TimerBadge>
      </Flex>
    </Flex>
  )
}

export default PremiumTimer

export interface IPremiumTimerProps {
  countTo: Date
}
